export const UPDATE_ADVANCED_FILTER_FORM_STATE = 'UPDATE_ADVANCED_FILTER_FORM_STATE';

